exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_option_tcWY9Lq04ySsJeQDQeU9G {\n  width: 100%;\n  height: 30px;\n}\n\n.IA_icon_3S9Z-wizSownSSrbfnAGmw {\n  float: left;\n}\n\n.IA_label_1xRGOpor9arj62h1bFbR_n {\n  float: left;\n  margin-left: 10px;\n  line-height: 30px;\n}", ""]);

// Exports
exports.locals = {
	"IA_option": "IA_option_tcWY9Lq04ySsJeQDQeU9G",
	"IA_icon": "IA_icon_3S9Z-wizSownSSrbfnAGmw",
	"IA_label": "IA_label_1xRGOpor9arj62h1bFbR_n"
};